import { render, staticRenderFns } from "./UnionManage.vue?vue&type=template&id=1399ee88&scoped=true&"
import script from "./UnionManage.vue?vue&type=script&lang=js&"
export * from "./UnionManage.vue?vue&type=script&lang=js&"
import style0 from "./UnionManage.vue?vue&type=style&index=0&id=1399ee88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399ee88",
  null
  
)

export default component.exports